import { render, staticRenderFns } from "./JoinTypePage.vue?vue&type=template&id=78a854f8"
import script from "./JoinTypePage.vue?vue&type=script&lang=js"
export * from "./JoinTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports